export const SIGN_UP_FIELDS: SignUpFieldsType[] = [
  'email',
  'password',
  'confirmPassword',
]

export type SignUpFieldsType = 'email' | 'password' | 'confirmPassword'
